<template>
    <div class="disabled-account">
        <brand-backdrop />

        <div class="disabled-account-content">
            <div class="disabled-account-badge">
                <span class="disabled-account-glow"></span>
                <span class="disabled-account-icon">
                    <v-icon size="44" color="error">mdi-credit-card-off-outline</v-icon>
                </span>
            </div>

            <div class="disabled-account-title">{{ title }}</div>

            <div class="disabled-account-message">
                <v-icon size="18" color="error" class="mr-2 mt-1">mdi-alert-circle-outline</v-icon>
                <div v-html="currentError"/>
            </div>

            <template v-if="paymentsEnabled">
                <v-btn
                    color="primary" depressed large block
                    class="black--text text-none font-weight-bold disabled-account-btn"
                    @click="goToPlan">
                    {{ $t('common.select_new_plan') }}
                </v-btn>

                <v-btn
                    text large block
                    class="text-none font-weight-medium disabled-account-btn-ghost"
                    @click="goToCard">
                    {{ $t('common.change_payment_method') }}
                </v-btn>
            </template>

            <div v-else-if="!hasNoSubscription" class="disabled-account-note">
                {{ $t('payment.change_plan_from_desktop') }}
            </div>
        </div>
    </div>
</template>

<script>

import scrollLock from '@/mixins/scrollLock'
import BrandBackdrop from '@/components/common/BrandBackdrop'

export default {
    name: "DisabledAccount",
    components: {
        BrandBackdrop,
    },
    mixins: [scrollLock],
    computed: {
        hasNoSubscription(vm = this) {
            return !vm.account?.stripeAccount?.currentSubscription?.id
        },
        title(vm = this) {
            if (vm.hasNoSubscription) return vm.$t('payment.account_without_plan')
            return vm.$t('common.account_disabled')
        },
        currentError(vm = this) {
            if (vm.hasNoSubscription) return vm.$t('payment.account_without_plan_redirect')
            let last4 = vm.account?.stripeAccount?.last4 || null
            let defaultMessage = vm.$t('payment_failed_messages.try_again_later')
            let failedReason = vm.account?.stripeAccount?.failedReason || null
            let reason = vm.$te(`payment_failed_messages.${failedReason}`) ?
                vm.$t(`payment_failed_messages.${failedReason}`) : defaultMessage
            if (last4) return vm.$t('payment_failed_messages.last_card', {last4}) + '<br>' + reason
            return vm.$t('coach.payment_method_required')
        },
    },
    methods: {
        goToPlan() {
            const vm = this
            vm.$router.push({name: `${vm.accountType}.select-plan`})
        },
        goToCard() {
            const vm = this
            vm.$router.push({name: `${vm.accountType}.credit-card`})
        },
    }
}
</script>

<style scoped>

.disabled-account {
    position: fixed;
    inset: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #06080C;
    padding: calc(40px + var(--safe-area-inset-top, 0px)) 24px calc(40px + var(--safe-area-inset-bottom, 0px));
    overflow-x: hidden;
    overflow-y: auto;
}

.disabled-account-content {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 380px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    animation: disabled-account-fade-up .5s ease both;
}

.disabled-account-badge {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 26px;
    animation: disabled-account-pop .6s cubic-bezier(.34, 1.56, .64, 1) both;
    animation-delay: .12s;
}

.disabled-account-glow {
    position: absolute;
    width: 260px;
    height: 260px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(232, 92, 92, 0.26) 0%, rgba(232, 92, 92, 0.1) 45%, transparent 70%);
    filter: blur(8px);
}

.disabled-account-icon {
    position: relative;
    width: 92px;
    height: 92px;
    border-radius: 50%;
    background: rgba(232, 92, 92, 0.12);
    border: 1px solid rgba(232, 92, 92, 0.32);
    display: flex;
    align-items: center;
    justify-content: center;
}

.disabled-account-title {
    font-size: 28px;
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1.15;
    color: #F2F5FA;
}

.disabled-account-message {
    display: flex;
    align-items: flex-start;
    text-align: left;
    width: 100%;
    margin-top: 18px;
    padding: 14px 16px;
    border-radius: 14px;
    background: rgba(232, 92, 92, 0.08);
    border: 1px solid rgba(232, 92, 92, 0.22);
    color: rgba(242, 245, 250, 0.78);
    font-size: 14px;
    line-height: 1.5;
}

.disabled-account-btn {
    margin-top: 28px;
}

.disabled-account-note {
    width: 100%;
    margin-top: 28px;
    padding: 14px 16px;
    border-radius: 14px;
    background: rgba(242, 245, 250, 0.06);
    border: 1px solid var(--v-outline-base);
    color: rgba(242, 245, 250, 0.78);
    font-size: 14px;
    line-height: 1.5;
}

.disabled-account-btn-ghost {
    margin-top: 12px;
    border: 1px solid var(--v-outline-base);
    color: var(--v-txtPrimary-base) !important;
}

@keyframes disabled-account-fade-up {
    from { opacity: 0; transform: translateY(14px); }
    to { opacity: 1; transform: none; }
}

@keyframes disabled-account-pop {
    0% { opacity: 0; transform: scale(.7); }
    60% { transform: scale(1.06); }
    100% { opacity: 1; transform: scale(1); }
}

</style>
